<template>
  <b-container class="py-2 py-md-5">
    <b-row>
      <div class="col-auto d-none d-md-block" style="width: 250px">
        <div class="side">
          <div class="title">
            商品列表
          </div>
          <div class="filter-box my-4 p-3">
            <div class="filter-title py-2 mb-2">
              透過以下分類篩選：
            </div>
            <div class="filter-item">
              <div class="filter-item-list">
                <b-form-group label="類型" class="variant-platform">
                  <b-form-checkbox-group
                    v-model="filter.tags"
                    :options="tags_list"
                    name="filterTag"
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
              <div class="filter-item-list">
                <b-form-group label="品牌" class="variant-platform">
                  <b-form-checkbox-group
                    v-model="filter.brandIDs"
                    :options="sortBrandList"
                    name="filterCompanyIDs_list"
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
              <div class="filter-item-list">
                <b-form-group label="廠商" class="variant-platform">
                  <b-form-checkbox-group
                    v-model="filter.companyIDs"
                    :options="companyIDs_list"
                    name="filterRandIDs"
                    stacked
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>
          </div>
          <b-button
            block
            squared
            type="button"
            @click="clearFilterTag"
            variant="platform_main"
            class="text-white px-3"
          >
            清除篩選
          </b-button>
        </div>
      </div>
      <div class="col">
        <div
          class="pb-3 d-flex d-md-none justify-content-between align-items-center "
        >
          <div class="title d-inline-block">
            商品列表
          </div>
          <b-button
            variant="link"
            class="nav-link p-0"
            :class="{ has_filter: hasFilter }"
            v-b-toggle.filterSidebar
          >
            <b-icon icon="funnel" variant="platform_main"></b-icon>
            <small class="text-platform_main">篩選</small>
          </b-button>
        </div>
        <b-input-group class="justify-content-center d-flex d-md-none mb-4">
          <b-form-input
            type="text"
            class="rounded-0"
            v-model="filter.keyword"
            placeholder="搜尋零件名稱"
          >
          </b-form-input>
          <b-input-group-append>
            <b-button
              block
              squared
              type="button"
              variant="platform_main"
              class="text-white px-3"
            >
              <b-icon icon="search" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <div class="product_list" v-if="product_list">
          <div
            class="product_list-top_bar mb-4 d-flex align-items-center justify-content-between"
          >
            <span class="d-none d-md-inline-block">
              {{ filterName }} 搜尋結果：
            </span>
            <span class="mr-auto"
              >共 {{ product_list.total }} 項商品，顯示第
              {{ product_list.from }} 至 {{ product_list.to }} 項結果</span
            >
            <b-button
              v-if="!!filterName"
              squared
              type="button"
              @click="clearFilterSearch"
              variant="outline-platform_main"
              class="px-3 d-none d-md-inline-block"
              size="sm"
            >
              清除搜尋
            </b-button>
          </div>
          <div class="row" v-if="product_list.data.length">
            <div
              class="col-6 col-lg-4 col-xl-3 mb-2 mb-sm-4 product-item"
              v-for="item in product_list.data"
              :key="item.id"
              @click="showModal(item.id)"
            >
              <div class="card product_card">
                <div class="imgBox p-2 p-sm-3">
                  <div class="imgBox-inner p-3">
                    <div class="imgBox-fit">
                      <img
                        :src="item.cover_image"
                        class="card-img-top"
                        :alt="item.name"
                      />
                    </div>
                  </div>
                </div>
                <div class="card-body p-2 p-sm-3 pt-0">
                  <p class="card-text mb-0 text-platform_main">
                    {{ item.serial_no }}
                  </p>
                  <h5 class="card-title">{{ item.name }}</h5>
                  <p class="price">{{ toThousands(item.price) }}</p>
                  <a
                    href="#"
                    @click.stop.prevent="addShoppingCar(item.id, 1)"
                    class="btn btn-platform_main card-button"
                  >
                    <b-icon icon="cart2"></b-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="pb-5">查無此零件</div>
          <b-pagination
            v-if="product_list.data.length"
            align="right"
            v-model="product_list.current_page"
            :total-rows="product_list.total"
            :per-page="product_list.per_page"
            first-number
            last-number
            @click.native="pagination(product_list.current_page)"
            class="platform_main"
          ></b-pagination>
        </div>
      </div>
    </b-row>
    <b-sidebar
      id="filterSidebar"
      shadow
      z-index="99"
      right
      backdrop
      title="搜尋篩選"
      class="sidebar"
      header-class="flex-row-reverse border-bottom"
    >
      <div class="px-3 py-2">
        <b-form-group label="動力類型">
          <v-select
            label="name"
            :reduce="type => type.value"
            :options="type_list"
            v-model="filter.type"
            placeholder="請選擇動力類型"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"
                ><b-icon icon="chevron-down"></b-icon
              ></span>
            </template>
          </v-select>
        </b-form-group>
        <b-form-group label="汽車品牌" v-if="brand_list.length">
          <v-select
            label="name"
            :reduce="brand => brand.id"
            :options="brand_list"
            v-model="filter.brand"
            placeholder="請選擇品牌"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"
                ><b-icon icon="chevron-down"></b-icon
              ></span>
            </template>
          </v-select>
        </b-form-group>
        <b-form-group label="車款" v-if="model_list.length">
          <v-select
            label="name"
            :reduce="model => model.id"
            :options="model_list"
            v-model="filter.model"
            placeholder="請選擇車款"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"
                ><b-icon icon="chevron-down"></b-icon
              ></span>
            </template>
          </v-select>
        </b-form-group>
        <b-form-group label="年份/c.c.數" v-if="year_list.length">
          <v-select
            label="publish_year"
            :reduce="year => year.id"
            :options="year_list"
            v-model="filter.year"
            placeholder="請選擇年份/c.c.數"
          >
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"
                ><b-icon icon="chevron-down"></b-icon
              ></span>
            </template>
          </v-select>
        </b-form-group>
        <hr />
        <b-form-group label="零件類型" class="variant-platform">
          <b-form-checkbox-group
            v-model="filter.tags"
            :options="tags_list"
            name="filterTag"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
        <hr />
        <b-form-group label="零件品牌" class="variant-platform">
          <b-form-checkbox-group
            v-model="filter.brandIDs"
            :options="sortBrandList"
            name="filterCompanyIDs_list"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
        <hr />
        <b-form-group label="廠商" class="variant-platform">
          <b-form-checkbox-group
            v-model="filter.companyIDs"
            :options="companyIDs_list"
            name="filterRandIDs"
            stacked
          ></b-form-checkbox-group>
        </b-form-group>
      </div>
      <template v-slot:footer="{ hide }">
        <b-button block squared @click="hide" variant="platform_main"
          >篩選</b-button
        >
        <b-button
          block
          squared
          @click="clearFilter"
          variant="platform_sub"
          class="mt-0"
          >清除篩選</b-button
        >
      </template>
    </b-sidebar>
    <b-modal
      id="modalProduct"
      :title="showProductData ? showProductData.name : ''"
      @hidden="hiddenModal"
      scrollable
      size="xl"
      footer-bg-variant="gray"
    >
      <div class="row" v-if="showProductData">
        <div class="col-lg-5 modal-image">
          <div v-if="showProductData.images.length">
            <div class="imgBox p-4">
              <div class="imgBox-inner">
                <div class="imgBox-fit">
                  <img
                    :src="showProductImg"
                    class="card-img-top"
                    :alt="showProductData.name"
                  />
                </div>
              </div>
            </div>
            <div class="row no-gutters product-img-list">
              <div
                class="col-3"
                v-for="(item, index) in showProductData.images"
                :key="index"
              >
                <div
                  class="imgBox p-2 p-sm-3"
                  @click="changeImg(item.image_link)"
                  :class="{ border: showProductImg == item.image_link }"
                >
                  <div class="imgBox-inner">
                    <div class="imgBox-fit">
                      <img :src="item.image_link" class="card-img-top" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="imgBox p-4">
              <div class="imgBox-inner">
                <div class="imgBox-fit">
                  <img
                    :src="imageOnerror"
                    class="card-img-top"
                    :alt="showProductData.name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="my-4 col-lg-7">
          <div class="price">{{ toThousands(showProductData.price) }}</div>
          <div class="row no-gutters info_list">
            <div class="col-auto info_list-title">零件編號</div>
            <div class="col">{{ showProductData.serial_no }}</div>
          </div>
          <div class="row no-gutters info_list">
            <div class="col-auto info_list-title">零件品牌</div>
            <div class="col">{{ showProductData.part_brands.name }}</div>
          </div>
          <div class="row no-gutters info_list">
            <div class="col-auto info_list-title">廠商</div>
            <div class="col">{{ showProductData.company.company_name }}</div>
          </div>
          <div class="row no-gutters info_list">
            <div class="col-auto info_list-title">通用汽車</div>
            <div class="col" v-if="!showProductData.categories.length">
              全適用
            </div>
          </div>
          <div>
            <table
              class="table mt-2 table-striped border"
              v-if="showProductData.categories.length"
            >
              <thead>
                <tr>
                  <th>汽車品牌</th>
                  <th>車款</th>
                  <th>動力類型</th>
                  <th>年份/.c.c數</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in showProductData.categories"
                  :key="'categories' + index"
                >
                  <td data-th="汽車品牌">{{ item.brand_name }}</td>
                  <td data-th="車款">{{ item.model_name }}</td>
                  <td data-th="動力類型">{{ getTypeName(item.type) }}</td>
                  <td data-th="年份/.c.c數">
                    {{ item.publish_year + " / " + item.displacing }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="info_list-title mt-2">商品介紹</div>
          <hr class="my-2" />
          <div v-html="showProductData.description"></div>
        </div>
      </div>
      <template #modal-footer>
        <div class="row no-gutters w-100">
          <div class="col-lg-5 mb-3 mb-lg-0">
            <div class="row no-gutters align-items-center">
              <div class="col-auto info_list-title">數量</div>
              <div class="col">
                <b-input-group class="bg-white">
                  <template #prepend>
                    <b-button
                      squared
                      variant="outline-secondary"
                      type="button"
                      class="px-2"
                      @click="count--"
                      :disabled="count == 1"
                      ><b-icon icon="dash"></b-icon
                    ></b-button>
                  </template>
                  <b-form-input
                    type="number"
                    v-model="count"
                    class="text-center"
                    style="border-color: #6c757d;"
                  ></b-form-input>
                  <template #append>
                    <b-button
                      variant="outline-secondary"
                      squared
                      type="button"
                      class="px-2"
                      @click="count++"
                      ><b-icon icon="plus"></b-icon
                    ></b-button>
                  </template>
                </b-input-group>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <b-button-group class="product-button-group ml-0 ml-lg-3">
              <b-button
                squared
                type="button"
                class="product-button-addcard px-0"
                @click="addShoppingCar"
                >加入購物車</b-button
              >
              <b-button
                squared
                type="button"
                class="product-button-shopping px-0"
                @click="testAddAndCheckout"
                >立即購買</b-button
              >
            </b-button-group>
          </div>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<style lang="scss" scoped>
.sidebar {
  ::v-deep .close {
    margin-left: auto;
    margin-right: 0 !important;
  }
  ::v-deep header {
    font-size: 20px;
  }
  ::v-deep .b-sidebar-footer {
    a {
      color: #fff;
    }
  }
  ::v-deep .custom-checkbox {
    margin: 10px 0;
  }
}
.has_filter {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 5px;
    background-color: $platform_main;
  }
}
.title {
  font-size: 24px;
  font-weight: bold;
}
.side {
  .title {
    padding: 10px 0;
    border-top: 1px solid #d1d8db;
    border-bottom: 1px solid #d1d8db;
  }
}
.filter-box {
  background-color: #f2f2f2;
  & ::v-deep .col-form-label {
    color: #616870;
    padding-bottom: 0;
  }
  & ::v-deep .custom-control {
    margin: 10px 0;
  }
}
.product_list-top_bar {
  border-top: 1px solid #d1d8db;
  border-bottom: 1px solid #d1d8db;
  font-size: 14px;
  min-height: 58px;
}
.product_card {
  background-color: #f2f2f2;
  border-color: #f2f2f2;
  border-radius: 0;
  position: relative;
  height: 100%;
  transition: all 0.3s;
  cursor: pointer;
  & ::v-deep .card-title {
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 1.5em;
    height: 3em;
    @include media-breakpoint-down(sm) {
      font-size: 16px;
    }
  }
  .price {
    color: $platform_main;
    font-weight: 600;
    font-size: 24px;
    &::before {
      content: "NT$";
      font-size: 14px;
    }
  }
  .card-button {
    opacity: 0;
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 0;
    background-color: transparent;
    border: none;
    z-index: 0;
    padding: 0;
    width: 46px;
    line-height: 43px;
    transition: all 0.3s;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0 70px 80px;
      border-color: transparent transparent $platform_main transparent;
      z-index: -1;
    }
    @include media-breakpoint-down(md) {
      opacity: 1;
    }
    @include media-breakpoint-down(sm) {
      position: relative;
      width: 100%;
      background-color: $platform_main;
      line-height: 1.8;
      &::after {
        content: none;
      }
    }
  }
  &:hover {
    background-color: #fff;
    border-color: $platform_main;
    .card-button {
      opacity: 1;
    }
  }
}
.product-img-list {
  .imgBox {
    cursor: pointer;
  }
}
.imgBox {
  &-inner {
    background-color: #fff;
  }
  &-fit {
    padding-top: 100%;
    position: relative;
    overflow: hidden;
  }
  & ::v-deep img {
    width: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
  }
}
.product_list ::v-deep .pagination {
  .page-item {
    &:first-child {
      .page-link {
        border-radius: 0;
      }
    }
    &:last-child {
      .page-link {
        border-radius: 0;
      }
    }
  }
}
.modal {
  &-image > div {
    position: sticky;
    top: 0;
  }
  .table {
    @include media-breakpoint-down(sm) {
      font-size: 14px;
      thead {
        display: none;
      }
      tr:nth-of-type(even) {
        background-color: rgb(222 226 230);
      }
      tbody td {
        display: block;
        border-top: 1px solid transparent;
        padding-top: 0;
        &:first-child {
          padding-top: 0.75rem;
        }
        &::before {
          content: attr(data-th);
          font-weight: bold;
          width: 100px;
          display: inline-block;
        }
      }
    }
  }
  .price {
    font-size: 24px;
    font-weight: bold;
    color: #fc7e00;
    &::before {
      content: "NT$";
      font-size: 14px;
    }
    @include media-breakpoint-down(sm) {
      font-size: 18px;
    }
  }
  .info_list {
    margin: 10px 0;
    &-title {
      color: #666666;
      width: 100px;
    }
  }
  .product-button {
    &-group {
      position: relative;
      display: flex;
      & ::v-deep button {
        display: block;
        margin-top: 0 !important;
      }
    }
    &-addcard {
      background-color: #666666;
    }
    &-shopping {
      background-color: $platform_main;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -19px;
        border-style: solid;
        border-width: 38px 38px 0 0;
        border-color: #666666 transparent transparent transparent;
        z-index: 1;
      }
      &::after {
        content: "";
        position: absolute;
        top: -1px;
        left: -19px;
        border-style: solid;
        border-width: 0 0 38px 38px;
        border-color: transparent transparent $platform_main transparent;
        z-index: 1;
      }
    }
  }
}
.product-item {
  @include media-breakpoint-down(sm) {
    &:nth-child(odd) {
      padding-right: 5px;
    }
    &:nth-child(even) {
      padding-left: 5px;
    }
  }
}
</style>
<script>
import { Toast } from "@/plugins/sweetalert2.js";
import { Data, ShoppingCar } from "@/assets/api/platform.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "Product",
  props: ["token", "search_product", "search_keyword"],
  components: { vSelect },
  data() {
    return {
      hasFilter: false,
      product_list: null,
      tags_list: [],
      companyIDs_list: [],
      brandIDs_list: [],
      category_list: [],
      brand_list: [],
      model_list: [],
      year_list: [],
      all_year_list: [],
      filter: {
        keyword: "",
        type: "",
        brand: "",
        model: "",
        year: "",
        displacing: "",
        tags: [],
        companyIDs: [],
        brandIDs: []
      },
      imageOnerror: "/img/image_onerror.jpg",
      type_list: [
        {
          name: "汽油車",
          value: "gas"
        },
        {
          name: "油電車",
          value: "hybrid"
        },
        {
          name: "電動車",
          value: "electric"
        },
        {
          name: "柴油車",
          value: "diesel"
        }
      ],
      showProductId: "",
      showProductData: null,
      showProductImg: "",
      count: 1
    };
  },
  created() {
    this.getBrand();
    this.getCategory();
    Data.tag(this.token)
      .then(res => {
        if (res.status <= 201) {
          res.data.forEach(val => {
            this.tags_list.push({
              text: val.name,
              value: val.id
            });
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "商品分類標籤讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
    Data.part_brand(this.token)
      .then(res => {
        if (res.status <= 201) {
          res.data.forEach(val => {
            this.brandIDs_list.push({
              text: val.name,
              value: val.id
            });
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "零件品牌資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
    Data.vendor(this.token)
      .then(res => {
        if (res.status <= 201) {
          res.data.forEach(val => {
            this.companyIDs_list.push({
              text: val.company_name,
              value: val.id
            });
          });
        } else {
          Toast.fire({
            icon: "error",
            title: "廠商資料讀取失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
    this.getProducts(1);
    if (this.search_keyword.length) {
      this.filter.keyword = this.search_keyword;
    }
  },
  computed: {
    filterName() {
      let text = "";
      text += this.filter.keyword + " ";
      this.type_list.forEach(val => {
        if (val.value == this.filter.type) {
          text += val.name + " ";
        }
      });
      this.category_list.forEach(val => {
        if (val.id == this.filter.brand) {
          text += val.name + " ";
        }
      });
      this.category_list.forEach(val => {
        val.models.forEach(model => {
          if (model.id == this.filter.model) {
            text += model.name + " ";
          }
        });
      });
      this.category_list.forEach(val => {
        val.models.forEach(model => {
          model.years.forEach(year => {
            if (year.id == this.filter.year) {
              text += year.publish_year + "(" + year.displacing + ") ";
            }
          });
        });
      });
      text = text.trim();
      return text;
    },
    sortBrandList() {
      if (!this.brandIDs_list.length) {
        return [];
      }
      const brandIDs_list = this.brandIDs_list;
      return brandIDs_list.sort((a, b) => {
        return a.text > b.text ? 1 : -1;
      });
    }
  },
  watch: {
    "filter.type": function(val) {
      this.brand_list = [];
      this.model_list = [];
      this.year_list = [];
      // this.filter.brand = "";
      // this.filter.model = "";
      // this.filter.year = "";
      if (val) {
        this.brand_list = [];
        this.all_year_list.forEach(year => {
          if (year.type == val) {
            const name = this.getBrandName(year.car_brand_id);
            if (this.brand_list.length) {
              for (let index = 0; index < this.brand_list.length; index++) {
                if (this.brand_list[index].id == year.car_brand_id) return;
              }
            }
            this.brand_list.push({
              id: year.car_brand_id,
              name: name
            });
          }
        });
      } else {
        this.getBrand();
      }
    },
    "filter.brand": function(val) {
      this.model_list = [];
      this.year_list = [];
      // this.filter.model = "";
      // this.filter.year = "";
      if (val && !this.filter.type) {
        Data.model(this.filter.brand, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.model_list = res.data;
            } else {
              Toast.fire({
                icon: "error",
                title: "汽車型號資料讀取失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        this.all_year_list.forEach(year => {
          if (year.type == this.filter.type && year.car_brand_id == val) {
            const name = this.getModelName(year.car_model_id);
            if (this.model_list.length) {
              for (let index = 0; index < this.model_list.length; index++) {
                if (this.model_list[index].id == year.car_model_id) return;
              }
            }
            this.model_list.push({
              id: year.car_model_id,
              name: name
            });
          }
        });
      }
    },
    "filter.model": function(val) {
      this.year_list = [];
      // this.filter.year = "";
      if (val && !this.filter.type) {
        Data.type(this.filter.brand, this.filter.model, this.token)
          .then(res => {
            if (res.status <= 201) {
              res.data.forEach(val => {
                this.year_list.push({
                  id: val.id,
                  publish_year:
                    val.publish_year + " / " + val.displacing + "c.c."
                });
              });
            } else {
              Toast.fire({
                icon: "error",
                title: "汽車型號資料讀取失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        this.all_year_list.forEach(year => {
          if (
            year.type == this.filter.type &&
            year.car_brand_id == this.filter.brand &&
            year.car_model_id == val
          ) {
            if (this.year_list.length) {
              for (let index = 0; index < this.year_list.length; index++) {
                if (this.year_list[index].id == year.id) return;
              }
            }
            this.year_list.push({
              id: year.id,
              publish_year: year.publish_year + " / " + year.displacing + "c.c."
            });
          }
        });
      }
    },
    search_product: {
      handler: function(val) {
        if (val) {
          Object.keys(this.filter).forEach(key => {
            Object.keys(val).forEach(item => {
              if (key == item) {
                this.filter[key] = val[item];
              }
            });
          });
        }
      },
      deep: true
    },
    search_keyword(val) {
      this.filter.keyword = val;
    },
    filter: {
      handler: function(val) {
        let hasFilterQty = 0;
        Object.keys(val).forEach(item => {
          if (
            typeof val[item] == "object"
              ? val[item].length
              : String(val[item]).length
          ) {
            hasFilterQty++;
          }
        });
        hasFilterQty ? (this.hasFilter = true) : (this.hasFilter = false);
        this.getProducts(1);
      },
      deep: true
    },
    showProductId(val) {
      if (val) {
        Data.product(val, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.showProductData = res.data;
              if (!this.showProductData.images.length) return;
              this.showProductImg = this.showProductData.images[0].image_link;
            } else {
              Toast.fire({
                icon: "error",
                title: "商品資料讀取失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
      }
    }
  },
  methods: {
    getBrand() {
      Data.brand(this.token)
        .then(res => {
          if (res.status <= 201) {
            this.brand_list = res.data;
          } else {
            Toast.fire({
              icon: "error",
              title: "汽車品牌資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getCategory() {
      Data.category()
        .then(res => {
          if (res.status <= 201) {
            this.category_list = res.data.data;
            res.data.data.forEach(brand => {
              brand.models.forEach(model => {
                model.years.forEach(year => {
                  this.all_year_list.push(year);
                });
              });
            });
          } else {
            Toast.fire({
              icon: "error",
              title: "詳細汽車資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    changeImg(url) {
      this.showProductImg = url;
    },
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
    getBrandName(id) {
      for (let index = 0; index < this.category_list.length; index++) {
        if (this.category_list[index].id == id) {
          return this.category_list[index].name;
        }
      }
    },
    getModelName(id) {
      for (let index = 0; index < this.category_list.length; index++) {
        for (let i = 0; i < this.category_list[index].models.length; i++) {
          if (this.category_list[index].models[i].id == id) {
            return this.category_list[index].models[i].name;
          }
        }
      }
    },
    getTypeName(val) {
      for (let index = 0; index < this.type_list.length; index++) {
        if (this.type_list[index].value == val) {
          return this.type_list[index].name;
        }
      }
    },
    getProducts(page) {
      let config = Object.assign({}, this.token);
      config.params = this.filter;
      config.params.page = page;
      Data.products(config)
        .then(res => {
          if (res.status <= 201) {
            this.product_list = res.data;
            this.onerrorForImg();
          } else {
            Toast.fire({
              icon: "error",
              title: "商品資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    onerrorForImg() {
      this.$nextTick(() => {
        var imgList = document.querySelectorAll("img");
        Array.prototype.forEach.call(imgList, item => {
          item.onerror = () => {
            item.src = this.imageOnerror;
          };
        });
      });
    },
    clearFilterTag() {
      this.filter.tags = [];
      this.filter.companyIDs = [];
      this.filter.brandIDs = [];
    },
    clearFilterSearch() {
      this.filter.keyword = "";
      this.filter.type = "";
      this.filter.brand = "";
      this.filter.model = "";
      this.filter.year = "";
      this.filter.displacing = "";
    },
    clearFilter() {
      this.clearFilterTag();
      this.clearFilterSearch();
    },
    pagination(currentPage) {
      this.getProducts(currentPage);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    showModal(id) {
      this.showProductId = id;
      this.$root.$emit("bv::show::modal", "modalProduct", "#btnShow");
      this.onerrorForImg();
    },
    hiddenModal() {
      this.showProductId = "";
      this.showProductData = null;
      this.count = 1;
    },
    addShoppingCar(id, count) {
      ShoppingCar.add(
        {
          productID: this.showProductId || id,
          count: this.count || count
        },
        this.token
      )
        .then(res => {
          if (res.data.status == "success") {
            Toast.fire({
              icon: "success",
              title: "已加入購物車"
            });
            this.$root.$emit("bv::hide::modal", "modalProduct", "#btnShow");
            this.getShoppingCar();
          } else {
            Toast.fire({
              icon: "error",
              title: "加入購物車失敗",
              text: res.status
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    testAddAndCheckout() {
      ShoppingCar.add(
        {
          productID: this.showProductId,
          count: this.count
        },
        this.token
      )
        .then(res => {
          if (res.data.status == "success") {
            this.$root.$emit("bv::hide::modal", "modalProduct", "#btnShow");
            this.$router.push({ name: "購物車" });
          } else {
            Toast.fire({
              icon: "error",
              title: "加入購物車失敗",
              text: res.status
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getShoppingCar() {
      ShoppingCar.get(this.token)
        .then(res => {
          if (res.status <= 201) {
            const shopping_car = res.data;
            let newQty = 0;
            Object.keys(shopping_car).forEach(key => {
              newQty = newQty + shopping_car[key].items.length;
            });
            this.$emit("shoppingCarQty", newQty);
          } else {
            Toast.fire({
              icon: "error",
              title: "購物車讀取失敗",
              text: res.status
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  mounted() {}
};
</script>
